import React from 'react'
import PropTypes from 'prop-types'
import { BarChart, Bar, XAxis, YAxis, Area, Tooltip, ResponsiveContainer, Text, Cell } from 'recharts'

const data = [
  { name: 'Great', percentage: 78, responses: 547 * 0.78, color: '#FFC658', emoji: '😊' },
  { name: 'Good', percentage: 40, responses: 547 * 0.4, color: '#00B894', emoji: '👍' },
  { name: 'Bad', percentage: 10, responses: 547 * 0.1, color: '#FF7675', emoji: '😠' },
]

const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    return (
      <div style={{ backgroundColor: '#fff', padding: '10px', border: '1px solid #ccc' }}>
        <p>{`${label}: ${payload[0].value}%`}</p>
        <p>{`Responses: ${Math.round(payload[0].payload.responses)}`}</p>
      </div>
    )
  }
  return null
}

// const CustomizedAxisTick = props => {
//   const { x, y, payload, value } = props
//   return (
//     <Text x={x} y={y} dx={-60} dy={5} textAnchor="start" fill="#666" fontSize={14}>
//       {`${value}%`}
//     </Text>
//   )
// }

const SurveyReviewChart = () => {
  return (
    <ResponsiveContainer width="100%" height={200}>
      <BarChart
        layout="vertical"
        data={data}
        margin={{
          top: 20,
          right: 80,
          left: 20,
          bottom: 5,
        }}
      >
        {/* <CartesianGrid />  */}
        <XAxis type="number" hide domain={[0, 100]} /> {/* X-axis for percentage, hidden as we'll use custom labels */}
        <YAxis
          type="category"
          dataKey="name"
          width={100}
          axisLine={false}
          tickLine={false}
          tick={false} // Hide default Y-axis ticks
        />
        <Tooltip content={<CustomTooltip />} />
        <Bar dataKey="percentage" barSize={30}>
          {data.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={entry.color} background={{}} />
          ))}
          {/* Custom labels for percentage and sentiment */}
          {data.map((entry, index) => (
            <Text
              key={`label-${index}`}
              x={entry.percentage > 0 ? entry.percentage + 5 : 5} // Adjust x position for percentage
              y={index * (200 / data.length) + 200 / data.length / 2 + 10} // Center vertically
              textAnchor="start"
              fill="#333"
              fontWeight="bold"
              fontSize={14}
            >
              {`${entry.percentage}%`}
            </Text>
          ))}
          {/* Custom labels for sentiment and emoji */}
          {data.map((entry, index) => (
            <Text
              key={`sentiment-label-${index}`}
              x={0} // Position at the start of the bar
              y={index * (200 / data.length) + 200 / data.length / 2 - 5} // Center vertically
              textAnchor="start"
              fill="#333"
              fontSize={14}
            >
              {entry.name}
            </Text>
          ))}
          {/* Custom labels for emoji */}
          {data.map((entry, index) => (
            <Text
              key={`emoji-${index}`}
              x={100} // Position to the right of the bar
              y={index * (200 / data.length) + 200 / data.length / 2 + 10} // Center vertically
              textAnchor="start"
              fill="#333"
              fontSize={20} // Adjust emoji size
            >
              {entry.emoji}
            </Text>
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  )
}

export default SurveyReviewChart

CustomTooltip.propTypes = {
  active: PropTypes.string,
  payload: PropTypes.array,
  label: PropTypes.string,
}
